import { BarTimeChart } from "../../metering_tab/bar_time_chart";
import { getBarTimeChartOptions } from "../../metering_tab/chart_options";
import { useTheme } from "@mui/material";

export function ProfitChart({ profits }) {
  const theme = useTheme();

  const utctime = profits.utctime.map((el) => new Date(1000 * el));
  const pp = profits.profit;
  const ppcumsum = pp.map(
    (
      (sum) => (value) =>
        (sum += value)
    )(0),
  );

  const data = {
    labels: utctime,
    datasets: [
      {
        fill: true,
        label: "Cumulatieve Winst (€)",
        data: ppcumsum,
        borderWidth: 0,
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
    ],
  };

  return <BarTimeChart data={data} />;
}

export function ElionChart({ metering }) {
  const theme = useTheme();

  const utctime = metering.utctime.map((el) => new Date(1000 * el));
  const flex = metering.flex.map((el) => el / 1000);
  const flex_setpoint = metering.flex_setpoint.map((el) => el / 1000);

  const data = {
    labels: utctime,
    datasets: [
      {
        fill: true,
        label: "Flex (kW)",
        data: flex,
        borderWidth: 0,
        borderColor: theme.palette.flex.main,
        backgroundColor: theme.palette.flex.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      {
        fill: false,
        label: "Setpoint",
        data: flex_setpoint,
        borderWidth: 2,
        borderColor: "grey",
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
        order: -1,
      },
    ],
  };

  return <BarTimeChart data={data} />;
}

export function InternalChart({ metering }) {
  const theme = useTheme();

  const utctime = metering.utctime.map((el) => new Date(1000 * el));
  const consumption = metering.total_consumption.map((el) => el);
  const production = metering.total_production.map((el) => -el);
  //const flex = metering.flex.map(el => el);
  //const inverterLoss = metering.map(el => el.inverter_loss);
  //const forecast = metering.map(el => 4*el.forecast);

  const data = {
    labels: utctime,
    datasets: [
      /*{
                fill: true,
                label: 'Flex',
                data: flex,
                borderWidth: 0,
                borderColor: theme.palette.flex.main,
                backgroundColor: theme.palette.flex.main,
                cubicInterpolationMode: 'monotone',
                pointStyle: false,
              },*/
      {
        fill: true,
        label: "Consumption",
        data: consumption,
        borderWidth: 0,
        borderColor: theme.palette.consumption.main,
        backgroundColor: theme.palette.consumption.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      /*{
              fill: true,
              label: 'Inverter loss',
              data: inverterLoss,
              borderWidth: 0,
              borderColor: theme.palette.inverterLoss.main,
              backgroundColor: theme.palette.inverterLoss.main,
              cubicInterpolationMode: 'monotone',
              pointStyle: false,
            },*/
      {
        fill: true,
        label: "Production",
        data: production,
        borderWidth: 0,
        borderColor: theme.palette.production.main,
        backgroundColor: theme.palette.production.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
      },
      // {
      //   fill: false,
      //   label: 'Forecast',
      //   data: forecast,
      //   borderWidth: 2,
      //   borderColor: 'grey',
      //   backgroundColor: 'transparent',
      //   cubicInterpolationMode: 'monotone',
      //   pointStyle: false,
      //   type: 'line',
      //   order: -1
      // },
    ],
  };

  return <BarTimeChart data={data} />;
}

export function SOCChart({ metering }) {
  const theme = useTheme();

  const utctime = metering.utctime.map((el) => new Date(1000 * el));
  const soc = metering.soc.map((el) => el);
  const soc_p25 = metering.soc_p25.map((el) => el);
  const soc_p75 = metering.soc_p75.map((el) => el);

  const data = {
    labels: utctime,
    datasets: [
      {
        type: "line",
        fill: false,
        label: "SOC",
        data: soc,
        borderWidth: 2,
        borderColor: theme.palette.soc.main,
        backgroundColor: theme.palette.soc.main,
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        order: 0,
      },
      {
        type: "line",
        fill: "+1",
        label: "SOC P25",
        data: soc_p25,
        borderWidth: 2,
        borderColor: "transparent",
        backgroundColor: "rgba(79, 121, 247,0.3)",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        order: 0,
      },
      {
        type: "line",
        fill: false,
        label: "SOC P75",
        data: soc_p75,
        borderWidth: 2,
        borderColor: "transparent",
        backgroundColor: "rgba(79, 121, 247,0.3)",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        order: 0,
      },
    ],
  };

  const options = getBarTimeChartOptions();
  options.scales.y.stacked = false;

  return <BarTimeChart data={data} options={options} />;
}
